"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupNode = void 0;
const react_1 = __importDefault(require("react"));
const text_1 = require("@visx/text");
const shape_1 = require("@visx/shape");
const componentStyle = {
    text: {
        fontSize: "12px",
    },
};
const GroupNode = ({ groupProps, id }) => {
    const textY = id.length > 14 ? 10 : 5;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(shape_1.Bar, { x: "0", y: "0", width: groupProps.width, height: groupProps.height, fill: "#D8E1E8", stroke: "#A7B6C2", ry: groupProps.ry, rx: groupProps.rx }),
        react_1.default.createElement(text_1.Text, { width: 40, y: groupProps.textY, x: groupProps.textX, textAnchor: "middle", style: componentStyle.text, fill: "#A7B6C2" }, id)));
};
exports.GroupNode = GroupNode;
//# sourceMappingURL=groupNode.js.map